var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Who's That Cosmere Character?")]),_c('div',{staticClass:"actions"},[_c('Button',{attrs:{"to":"/game/setup"}},[_vm._v("\n      Set up Game\n    ")]),_c('Button',[_vm._v("Submit clues")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }